import { FC } from 'react';
import Link from 'next/link';
import classNames from 'classnames';
import ForwardIcon from 'icons/forward';
import { AmplienceNavColumnProps } from '.';
import { gtmMenuNavigation } from 'helpers/utils/gtm-events/gtmInteraction';
export interface AmplienceNavColumnMobileProps extends AmplienceNavColumnProps {
  isOpen: boolean;
  onClick: () => void;
  className?: string;
}
const AmplienceNavColumnMobile: FC<AmplienceNavColumnMobileProps> = ({
  mainTitle,
  rows,
  isOpen,
  onClick,
  mainLink,
  className,
}) => {
  return (
    <li className={className + ' flex w-full flex-col items-center justify-between border-b p-5'}>
      <div className="flex w-full items-center justify-between">
        {mainLink ? (
          <Link
            onClick={() => {
              gtmMenuNavigation({ click_location: 'header', click_name: mainTitle });
            }}
            href={mainLink || ''}
            className="flex shrink-0 text-sm font-semibold leading-[17px] text-[#222222]"
            aria-label={mainTitle}
          >
            {mainTitle}
          </Link>
        ) : (
          <div className="flex shrink-0 text-sm font-semibold leading-[17px] text-[#222222]">{mainTitle}</div>
        )}
        <button
          data-testid={`nav-group-arrow-${mainTitle}`}
          onClick={onClick}
          className="flex w-fit grow justify-end p-0"
          aria-label={`${mainTitle}`}
        >
          <ForwardIcon className={classNames({ 'rotate-90': !isOpen, '-rotate-90': isOpen })} />
        </button>
      </div>
      {isOpen && (
        <ul className="mt-4 flex w-full flex-col font-light">
          {rows?.map((row, index) => {
            return (
              <li key={`nav-column-mobile-${mainTitle}-${row.title}-${index}`} className="py-1">
                <Link
                  onClick={() => {
                    gtmMenuNavigation({ click_location: 'header', click_name: row.title });
                  }}
                  className="inline-block text-[13px] font-normal leading-[19px] text-[#222222] hover:underline"
                  href={row.link || ''}
                  aria-label={row.title}
                >
                  {row.title}
                </Link>
              </li>
            );
          })}
        </ul>
      )}
    </li>
  );
};

export default AmplienceNavColumnMobile;
